export default class Guid {
    public static get empty(): string {
        return '00000000-0000-0000-0000-000000000000';
    }
}